module.exports = __webpack_public_path__ + "static/media/default-event-thumbnail.9c724d00.png";